/**
 * Shared date formatting utilities
 */

/**
 * Format a date string or Date object to a localized date string
 * @param {string|Date} dateInput - ISO date string or Date object
 * @param {Object} options - Intl.DateTimeFormat options
 * @returns {string} Formatted date string or 'N/A' for invalid inputs
 */
export const formatDate = (dateInput, options = {}) => {
  if (!dateInput) return 'N/A';
  
  try {
    const date = new Date(dateInput);
    
    // Check if the date is valid
    if (isNaN(date.getTime())) {
      return 'N/A';
    }
    
    const defaultOptions = {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      ...options
    };
    
    return date.toLocaleDateString('en-US', defaultOptions);
  } catch {
    return 'N/A';
  }
};

/**
 * Format a date with time included
 * @param {string|Date} dateInput - ISO date string or Date object
 * @returns {string} Formatted date and time string or 'N/A' for invalid inputs
 */
export const formatDateTime = (dateInput) => {
  return formatDate(dateInput, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};
